import { render, staticRenderFns } from "./addCarNewCard.vue?vue&type=template&id=6b55b4e6"
import script from "./addCarNewCard.vue?vue&type=script&lang=js"
export * from "./addCarNewCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports